import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import FooterCorp from "../modulos/footerCorp";
import axios from "axios";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

import CuerpoMenu from "./CuerpoMenu";
const DivisionCuerpo = () => {
    const [secciones, setSecciones] = useState([]); // Secciones obtenidas de la API
    const [compañias, setCompanias] = useState([]); // Compañías agrupadas
    const navitate = useNavigate()
    const Usuario = ObtieneDatosCookies()
    const volver = () => {
        navitate('/usuarioLogueado')
    }

    const obtenerSecciones = async () => {
        try {

            const response = await axios.post(
                "https://wwwa.isepsantafe.net.ar/expedientes/devuelveSecciones"
            );
            const seccionesData = response.data || [];
            setSecciones(seccionesData);

            // Agrupar las secciones por compañía
            const companiasAgrupadas = seccionesData.reduce((acc, seccion) => {
                const { nombre } = seccion.Compania;
                if (!acc[nombre]) {
                    acc[nombre] = [];
                }
                acc[nombre].push(seccion);
                return acc;
            }, {});

            // Obtener los nombres de las compañías para el primer select
            setCompanias(Object.keys(companiasAgrupadas));
        } catch (error) {
            console.error("Error al obtener las secciones", error);
        }
    };

    useEffect(() => {

        obtenerSecciones();
        return () => {

        };
    }, []);

    return (<>

        <CuerpoMenu/>
      
    </>)
}
export default DivisionCuerpo